
function opp(word) {
    if (word === 'white') {return 'black';}
    else if (word === 'black') {return 'white'}
    else if (word === 'win') {return 'lose'}
    else if (word === 'lose') {return 'win'}
    else if (word === 'draw') {return 'draw'}
    else if (word === 'p1') {return 'p2'}
    else if (word === 'p2') {return 'p1'}
    else {return '';}

}

export default opp;